// src/views/auth/ResetSenhaPage.jsx
// Página pública de redefinição de senha (rota /reset-senha?token=XXX).
// Não usa AuthProvider — independente.
import React, { useState, useEffect } from "react";
import authService from "../../services/authService";
import PasswordStrengthBar from "../../components/ui/PasswordStrengthBar";
import Banner from "../../components/ui/Banner";

export default function ResetSenhaPage() {
  const [token, setToken] = useState("");
  const [nova, setNova] = useState("");
  const [confirma, setConfirma] = useState("");
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState(null);     // { tipo, texto }
  const [concluido, setConcluido] = useState(false);

  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const t = params.get("token") || "";
      if (!t) setMsg({ tipo:"danger", texto:"Link inválido. Solicite uma nova redefinição." });
      setToken(t);
    } catch {
      setMsg({ tipo:"danger", texto:"Link inválido." });
    }
  }, []);

  const validar = () => {
    if (!token) return "Token ausente. Solicite uma nova redefinição.";
    if (!nova) return "Informe a nova senha.";
    if (nova.length < 6) return "A senha deve ter ao menos 6 caracteres.";
    if (nova !== confirma) return "As senhas não conferem.";
    return null;
  };

  const submeter = async (e) => {
    e?.preventDefault?.();
    const erro = validar();
    if (erro) { setMsg({ tipo:"warning", texto:erro }); return; }
    setLoading(true); setMsg(null);
    try {
      const r = await authService.resetSenha(token, nova);
      setConcluido(true);
      setMsg({ tipo:"success", texto: r?.message || "Senha redefinida com sucesso." });
    } catch (e2) {
      setMsg({ tipo:"danger", texto: e2?.message || "Não foi possível redefinir a senha." });
    } finally {
      setLoading(false);
    }
  };

  const irParaLogin = () => {
    window.location.href = "/";
  };

  return (
    <div style={{
      minHeight:"100vh",
      background:"linear-gradient(135deg,#1B3A6B,#2563EB)",
      display:"flex",alignItems:"center",justifyContent:"center",padding:"20px",
    }}>
      <div style={{
        width:"100%",maxWidth:440,background:"var(--bg-surface)",borderRadius:14,
        boxShadow:"0 20px 60px rgba(0,0,0,.25)",overflow:"hidden",
      }}>
        <div style={{
          background:"linear-gradient(135deg,#1B3A6B,#2563EB)",color:"#fff",
          padding:"22px 28px",textAlign:"center",
        }}>
          <i className="bi bi-shield-lock-fill" style={{fontSize:36,opacity:.95}}/>
          <h2 style={{margin:"8px 0 4px",fontSize:20}}>Redefinir senha</h2>
          <div style={{fontSize:13,opacity:.85}}>Crie uma senha forte para sua conta</div>
        </div>

        <div style={{padding:"24px 28px"}}>
          {msg && (
            <Banner tipo={msg.tipo}>{msg.texto}</Banner>
          )}

          {concluido ? (
            <div style={{textAlign:"center",padding:"20px 0"}}>
              <i className="bi bi-check-circle-fill" style={{fontSize:56,color:"#10B981"}}/>
              <h3 style={{margin:"12px 0 4px",fontSize:18,color:"#065F46"}}>Tudo certo!</h3>
              <p style={{color:"var(--gray-500)",fontSize:13,margin:"4px 0 20px"}}>
                Sua senha foi alterada. Faça login com a nova senha.
              </p>
              <button className="btn btn-primary" onClick={irParaLogin}>
                <i className="bi bi-box-arrow-in-right me-2"/>
                Ir para login
              </button>
            </div>
          ) : (
            <form onSubmit={submeter}>
              <div style={{marginBottom:14}}>
                <label style={{fontSize:12,fontWeight:600,color:"var(--gray-600)",display:"block",marginBottom:4}}>
                  Nova senha
                </label>
                <input
                  type={show?"text":"password"}
                  className="form-control"
                  value={nova}
                  onChange={e=>setNova(e.target.value)}
                  placeholder="Mínimo 6 caracteres"
                  autoComplete="new-password"
                  disabled={loading || !token}
                  autoFocus
                />
                <PasswordStrengthBar senha={nova} />
              </div>

              <div style={{marginBottom:14}}>
                <label style={{fontSize:12,fontWeight:600,color:"var(--gray-600)",display:"block",marginBottom:4}}>
                  Confirmar nova senha
                </label>
                <input
                  type={show?"text":"password"}
                  className="form-control"
                  value={confirma}
                  onChange={e=>setConfirma(e.target.value)}
                  placeholder="Repita a senha"
                  autoComplete="new-password"
                  disabled={loading || !token}
                />
                {confirma && nova !== confirma && (
                  <div style={{fontSize:11,color:"#991B1B",marginTop:4}}>
                    <i className="bi bi-exclamation-circle me-1"/>
                    As senhas não conferem.
                  </div>
                )}
              </div>

              <label style={{display:"flex",alignItems:"center",gap:6,fontSize:12,color:"var(--gray-500)",cursor:"pointer",marginBottom:18}}>
                <input type="checkbox" checked={show} onChange={e=>setShow(e.target.checked)}/>
                Mostrar senha
              </label>

              <button type="submit" className="btn btn-primary w-100"
                disabled={loading || !token}>
                {loading ? (
                  <><span className="spinner-border spinner-border-sm me-2"/>Redefinindo...</>
                ) : (
                  <><i className="bi bi-shield-check me-2"/>Redefinir senha</>
                )}
              </button>

              <div style={{textAlign:"center",marginTop:14}}>
                <button type="button" onClick={irParaLogin}
                  style={{background:"none",border:"none",color:"#1B3A6B",fontSize:13,fontWeight:600,cursor:"pointer"}}>
                  <i className="bi bi-arrow-left me-1"/>
                  Voltar ao login
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
